document.addEventListener("DOMContentLoaded", function() {
    function adjustDropdowns() {
        let dropdownMenus = document.querySelectorAll(".mega-menu"),
            scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        dropdownMenus.forEach(menuItem => {
            let dropdown = menuItem.querySelector(".mega-menu__content");
            if (window.innerWidth > 768 && dropdown) {
                let rect = menuItem.getBoundingClientRect();
                // console.log(-rect.left, scrollbarWidth, rect),
                  dropdown.style.width = "100vw", dropdown.style.left = "0"
            } else dropdown && (dropdown.style.width = "", dropdown.style.left = "")
        })
    }
    adjustDropdowns(), window.addEventListener("resize", adjustDropdowns)

  // function openCCIMENU(){
  //   let cciLink = document.querySelectorAll('.button-wrapper');
  //   cciLink.addEvent
  // }


});



document.addEventListener("DOMContentLoaded", function () {
  // ---- Handle Mega Menu hover for <details> ---- //
  document.querySelectorAll("header-menu details").forEach((detail) => {
    let timeout;

    detail.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      detail.setAttribute("open", true);
    });

    detail.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        detail.removeAttribute("open");
      }, 200); // short delay to allow movement to submenu
    });

    const menuContent = detail.querySelector(".mega-menu__content");
    if (menuContent) {
      menuContent.addEventListener("mouseenter", () => clearTimeout(timeout));
      menuContent.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
          detail.removeAttribute("open");
        }, 200);
      });
    }
  });

  // ---- Handle .cci-custom-menu1 and .cci-custom-menu2 ---- //
  function handleCCIMenu(wrapperSelector, menuSelector) {
    const trigger = document.querySelector(wrapperSelector);
    const menu = document.querySelector(menuSelector);
    let timeout;

    if (trigger && menu) {
      trigger.addEventListener("mouseenter", () => {
        clearTimeout(timeout);
        menu.style.display = "block";
      });

      trigger.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
          menu.style.display = "none";
        }, 200);
      });

      menu.addEventListener("mouseenter", () => {
        clearTimeout(timeout);
        menu.style.display = "block";
      });

      menu.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
          menu.style.display = "none";
        }, 200);
      });
    }
  }

  // Apply to both menus
  handleCCIMenu(".button-wrapper1", ".cci-custom-menu1");
  handleCCIMenu(".button-wrapper2", ".cci-custom-menu2");
});





/*
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.button-wrapper1, .button-wrapper2');
  const menus = document.querySelectorAll('.cci-custom-menu1, .cci-custom-menu2');

  if (buttons.length && menus.length) {
    buttons.forEach((button, index) => {
      button.addEventListener('click', function () {
        const menu = menus[index] || menus[0]; // fallback for safety
        const currentDisplay = window.getComputedStyle(menu).display;

        if (currentDisplay === 'none') {
          menu.style.display = 'block';
          console.log(`Menu ${index} shown`);
        } else {
          menu.style.display = 'none';
          console.log(`Menu ${index} hidden`);
        }
      });
    });
  } else {
    console.warn('No buttons or menus found:', { buttons, menus });
  }
});
*/

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.button-wrapper1, .button-wrapper2');
  const menus = document.querySelectorAll('.cci-custom-menu1, .cci-custom-menu2');

  if (buttons.length && menus.length) {
    buttons.forEach((button, index) => {
      button.addEventListener('click', function (event) {
        event.stopPropagation(); // Prevent the document click handler from immediately hiding the menu

        const menu = menus[index] || menus[0]; // fallback for safety
        const currentDisplay = window.getComputedStyle(menu).display;

        // First hide all menus
        menus.forEach(m => m.style.display = 'none');

        // Then toggle the clicked one
        if (currentDisplay === 'none') {
          menu.style.display = 'block';
          console.log(`Menu ${index} shown`);
        } else {
          console.log(`Menu ${index} hidden`);
        }
      });
    });

    // Hide menus when clicking outside
    document.addEventListener('click', function (event) {
      // If the click is NOT inside a button or menu, hide all menus
      const isClickInsideButtonOrMenu = Array.from(buttons).some(button => button.contains(event.target)) ||
                                         Array.from(menus).some(menu => menu.contains(event.target));

      if (!isClickInsideButtonOrMenu) {
        menus.forEach(menu => {
          if (menu.style.display !== 'none') {
            menu.style.display = 'none';
            console.log('Menu hidden due to outside click');
          }
        });
      }
    });
  } else {
    console.warn('No buttons or menus found:', { buttons, menus });
  }
});


// adaptive height of mega-menu title
function syncMegaTitleHeight() {
  document.querySelectorAll('.mega-menu__list').forEach(menu => {

    const columns = menu.querySelectorAll('.mega-column');
    if (columns.length > 2 && menu.querySelector('.mega-column:nth-child(2)')) {
      const titles = menu.querySelectorAll('.mega-column .mega-title');
      let maxHeight = 0;

      titles.forEach(t => {
        t.style.minHeight = 'auto';
      });

      titles.forEach(t => {
        maxHeight = Math.max(maxHeight, t.offsetHeight);
      });

      titles.forEach(t => {
        t.style.minHeight = `${maxHeight}px`;
      });
    }
  });
}
window.addEventListener('DOMContentLoaded', syncMegaTitleHeight);
window.addEventListener('resize', syncMegaTitleHeight);
